export const PROFILE = {
  name: 'Ezzddinne Mhamdi',
  photo: '/photo-profile.png',
  role: 'Platform Engineer',
  tagline: 'Build → Automate → Secure → Observe',
  summary:
    'I build cloud infrastructure, Kubernetes platforms, GitOps workflows, and developer self-service systems.',
  domain: 'https://ezzddinnemhamdi.dev',
  email: 'ezzddinne.mhamdi@outlook.com',
  phone: '+216 50 119 340',
  phoneHref: '+21650119340',
  location: 'Monastir, Tunisia',
  github: 'https://github.com/ezzddinne',
  linkedin: 'https://www.linkedin.com/in/ezzddine-mhamdi',
  medium: 'https://medium.com/@ezzddinne.mhamdi',
  availability: 'Open to Platform Engineering, DevOps, Cloud, DevSecOps & SRE roles',
}

export const MARQUEE_TECH = [
  'AWS',
  'EKS',
  'Azure',
  'AKS',
  'GCP',
  'Kubernetes',
  'Terraform',
  'Ansible',
  'Helm',
  'Argo CD',
  'GitHub Actions',
  'GitLab CI',
  'Backstage',
  'Crossplane',
  'Karpenter',
  'vCluster',
  'Docker',
  'Vault',
  'OIDC',
  'Tailscale',
  'CrowdSec',
  'Kyverno',
  'Trivy',
  'Cosign',
  'Falco',
  'Istio',
  'Prometheus',
  'Grafana',
  'Loki',
  'Tempo',
  'OpenTelemetry',
  'Traefik',
  'Linux',
  'Python',
  'Go',
]